<template>
  <v-footer app absolute color="transparent">
    <v-spacer></v-spacer>
    <span class="font-weight-light pr-4">Privacy Policy</span>
    <span class="caption">&copy; 2019 Pilviotus Oy</span>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
  }),
};
</script>

<style>
.mylogo {
  background: linear-gradient(135deg, #f5a925 20%, rgb(232, 68, 231) 70%, rgb(32, 109, 236) 100%);
  background: linear-gradient(90deg, #f5a925 40%, rgb(135, 179, 250) 100%);
  background: linear-gradient(270deg, #f5a925 60%, rgb(32, 109, 236) 100%);
  background: rgba(0,0,244,1);
}

</style>
